type AnalyticsEventParams = Record<string, string | number | boolean | null>;

declare global {
  interface Window {
    gtag?: (
      command: 'event',
      eventName: string,
      eventParams?: AnalyticsEventParams
    ) => void;
    fbq?: (
      command: 'track',
      eventName: string,
      eventParams?: AnalyticsEventParams
    ) => void;
  }
}

export const sendAnalyticsEvent = (
  eventName: string,
  eventParams?: AnalyticsEventParams
) => {
  if (typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, eventParams);
};

export const sendMetaPixelEvent = (
  eventName: string,
  eventParams?: AnalyticsEventParams
) => {
  if (typeof window.fbq !== 'function') {
    return;
  }

  window.fbq('track', eventName, eventParams);
};
